module.exports = __webpack_public_path__ + "media/images/free_preview_landscape-cda6727dd18c5b4cf0c3d0257311bca1.png";